import PropTypes from 'prop-types'

import DeliveryFilter from '@aytm/app/stats/page/question-views/mn/DeliveryFilter'

const DeliveryControls = ({ options, value, onChange, disabled }) => (
  <DeliveryFilter options={options} value={value} onChange={onChange} disabled={disabled} />
)

DeliveryControls.propTypes = {
  options: PropTypes.array,
  value: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
}

DeliveryControls.displayName = 'DeliveryControls'

export default DeliveryControls
